module.exports = __webpack_public_path__ + "static/media/upload_enable.7e9935bf.svg";